import { render } from "./UspReportAmountTile.vue?vue&type=template&id=4e51dbe4&scoped=true"
import script from "./UspReportAmountTile.vue?vue&type=script&lang=js"
export * from "./UspReportAmountTile.vue?vue&type=script&lang=js"

import "./UspReportAmountTile.vue?vue&type=style&index=0&id=4e51dbe4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e51dbe4"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip});
